import React, { useCallback, memo } from 'react';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { LifeSubNavLinkItems } from './lifeSubNavLinkItems';
import { LifeNavCloseButton } from './lifeNavCloseButton';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { lifeSubNavMenuAction } from '../../common/actions/lifePageSubNavigationActions';

interface LifeNavModalProps {
    isOpen: boolean;
    routePath: string;
    lifeSubNavMenuAction(open: boolean): void;
}
const mapStoreStateToProps = (storeState: any) => {
    const { lifeSubNavMenu, appState } = storeState || {};
    const { routePath } = appState?.appState || {};
    const { isOpen } = lifeSubNavMenu || {};
    return {
        isOpen,
        routePath
    };
};

const mapDispatchToProps = {
    lifeSubNavMenuAction
};

export const LifeNavModal = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    isOpen,
    routePath,
    lifeSubNavMenuAction
}: LifeNavModalProps) => {
   
    const onClose = useCallback(() => {
        lifeSubNavMenuAction(false);
    }, []);

    return (
        <Modal open={isOpen} onClose={onClose} showCloseIcon={false} styles={modalStyles}>
            <Container>
                <LifeNavCloseButton returnPath={routePath} close={onClose} />
                <LinkItemsWrapper>
                    <LifeSubNavLinkItems />
                </LinkItemsWrapper>
            </Container>
        </Modal>
    );
}));

LifeNavModal.displayName = 'LifeNavModal';

const modalStyles = {
    overlay: {
        background: 'rgba(48,67,80,0.98)'
    },
    modal: {
        boxShadow: '0px 0px 0px 0px'
    }
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #555555;
    width: 440px;
    font-size: 16px;
    padding: 48px 0px;
    background: rgba(48,67,80,0.98);
    @media ${smallMediaQuery} {
        width: 100%;
    }
    &.modal {
        box-shadow: 0;
    }
`;

const LinkItemsWrapper = styled.div`
    width: 100%;
    background: rgba(255,255,255, 1);
    padding: 0 13px;
`;